// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
export var codeMarkSharedStyles = function codeMarkSharedStyles() {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
      '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      display: 'inline',
      padding: '2px 0.5ch',
      backgroundColor: "var(--ds--code--bg-color,".concat("var(--ds-background-neutral, #091E420F)", ")"),
      borderRadius: "var(--ds-border-radius, 3px)",
      borderStyle: 'none',
      boxDecorationBreak: 'clone',
      color: "var(--ds-text, #172B4D)",
      fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      fontSize: '0.875em',
      fontWeight: "var(--ds-font-weight-regular, 400)",
      overflow: 'auto',
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap'
    }
  });
};